import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import categoryApi from '../../api/category.api';
import { EComponent } from '../../models/base';
import { ICategory } from '../../models/category.model';

type Props = {
  value?: string | null;
  onChange?: (value: ICategory | null) => void;
  component?: EComponent;
};

const CategorySelect = (props: Props) => {
  const [dropdownItems, setDropdownItems] = useState<ICategory[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await categoryApi.getAll(props.component);

      setDropdownItems(res.data);
    } catch (error) {
      console.error('Error fetching dropdown items:', error);
    } finally {
      setLoading(false);
    }
  }, [props.component]);

  useEffect(() => {
    // Simulate initial load or trigger load on component mount
    fetchData();
  }, [fetchData]);

  return (
    <FormControl fullWidth>
      <InputLabel>Start-up</InputLabel>
      <Select
        size="small"
        label="Start-up"
        value={props.value || 'no-value'}
        onChange={(e) => {
          if (e.target.value === 'no-value') {
            props.onChange?.(null);
          }
          const item = dropdownItems.find((i) => i.id === e.target.value);
          if (item) {
            props.onChange?.(item);
          }
        }} // Handle select change here
        displayEmpty
        renderValue={(selected) => {
          if (selected === 'no-value') {
            return 'Select an item';
          }
          const item = dropdownItems.find((i) => i.id === selected);

          return item?.title || 'Select an item';
        }}
      >
        {loading ? (
          <MenuItem disabled>
            <CircularProgress size={24} />
          </MenuItem>
        ) : (
          <MenuItem key={'empty'} value={'no-value'} sx={{ color: 'gray' }}>
            Empty
          </MenuItem>
        )}
        {!loading &&
          dropdownItems.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.title}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default CategorySelect;
